import { useSelector } from 'react-redux';

import { api } from '../../../api';
import infoIcon from '../../../assets/images/icon-filled-alert-info.svg';
import { SkeletonLoader } from '../../../components/SkeletonLoader';
import { getIsNZuser } from '../../../selectors/hubSelector';

export const useSupportInfo = () => {
  const { data, isLoading } = api.personalization.personalizationContent.useQuery();
  const isNZUser = useSelector(getIsNZuser);

  return {
    data: isNZUser ? data?.supportBar?.nz : data?.supportBar?.au,
    isLoading,
  };
};

const CustomerSupportInfo = () => {
  const { data, isLoading } = useSupportInfo();

  if (isLoading) {
    return (
      <div className="container mr-auto flex flex-col gap-y-2">
        <SkeletonLoader loading className="h-5 w-full" />
        <SkeletonLoader loading className="h-5 w-full" />
        <SkeletonLoader loading className="h-5 w-full" />
      </div>
    );
  }

  if (!data?.enabled) {
    return null;
  }

  return (
    <div className="container mr-auto rounded-lg border border-blue-500 bg-blue-100 p-5">
      <div className="flex flex-row">
        <img src={infoIcon} alt="info" className="mr-3 h-6 w-6" />
        <div className="font-semibold text-blue-500">{data.title}</div>
      </div>
      <div className="ml-9 mt-2 text-blue-500">{data.message}</div>
    </div>
  );
};

export default CustomerSupportInfo;
